<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des wallets</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <!-- Alerte pour les notifications -->
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>

        <!-- Modal de modification -->
        <modal :adaptive="true"
               :height="'auto'"
               :clickToClose="false"
               :draggable="false"
               :resizable="false"
               name="modal-fade"
               style="max-height: 90vh; overflow-y: auto;">
          <v-card class="wallet-edit-card">
            <v-toolbar
                color="#01579B"
                dark
                flat
                class="modal-header"
            >
              <v-icon left>mdi-wallet</v-icon>
              <v-toolbar-title class="modal-title">Modifier wallet</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide"
                  icon
                  class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-alert :color="AlertColorS(typeS)"
                     :dismissible="true"
                     :value="true"
                     border="top"
                     class="pre-formatted multi-line ma-0"
                     colored-border
                     elevation="2"
                     icon="check_circle"
                     v-if="typeS">
              {{ text }}
            </v-alert>

            <v-card-text class="pb-0">
              <v-container class="pa-2">
                <v-card flat class="wallet-info-card pa-2">
                  <div class="wallet-info-header">
                    <v-chip color="primary" label small class="step-chip">
                      <v-icon small left>mdi-information-outline</v-icon>
                      Infos du wallet
                    </v-chip>
                  </div>

                  <!-- Informations employé -->
                  <v-row dense>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Matricule</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          readonly
                          class="centered-input mb-2"
                          v-model="editedItem.matricule">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Nom du salarié</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          readonly
                          class="centered-input mb-2"
                          v-model="editedItem.employeeName">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Règles sur la même ligne -->
                  <v-row dense>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Règle entreprise</label>
                      <v-select
                          filled
                          dense
                          hide-details
                          :items="ruleTypes"
                          item-text="name"
                          item-value="value"
                          class="centered-input mb-2"
                          v-model="editedItem.ruleCompany">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Règle personnelle</label>
                      <v-select
                          filled
                          dense
                          hide-details
                          :items="ruleTypes"
                          item-text="name"
                          item-value="value"
                          class="centered-input mb-2"
                          v-model="editedItem.rulePersonal">
                      </v-select>
                    </v-col>
                  </v-row>

                  <!-- Soldes sur la même ligne -->
                  <v-row dense>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Solde entreprise</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          type="number"
                          class="centered-input mb-2"
                          v-model="editedItem.soldeCompany">
                        <template v-slot:append>
                          <span class="currency-label">FCFA</span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Solde personnel</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          type="number"
                          class="centered-input mb-2"
                          v-model="editedItem.soldePersonnel">
                        <template v-slot:append>
                          <span class="currency-label">FCFA</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Bouton activé/désactivé -->
                  <v-row dense class="mt-2 wallet-controls">
                    <!-- État du wallet -->
                    <v-col cols="12" sm="4" class="px-2">
                      <label class="field-label text-center d-block">État du wallet</label>
                      <div class="radio-group">
                        <v-radio-group v-model="editedItem.disabled" hide-details class="mt-0 pt-0">
                          <v-radio :value="false" color="success">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon small color="success" class="mr-1">mdi-check</v-icon>
                                <span>Activé</span>
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="true" color="error">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon small color="error" class="mr-1">mdi-close</v-icon>
                                <span>Désactivé</span>
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </div>
                    </v-col>

                    <!-- Verrouillage -->
                    <v-col cols="12" sm="4" class="px-2">
                      <label class="field-label text-center d-block">Verrouillage</label>
                      <div class="radio-group">
                        <v-radio-group v-model="editedItem.locked" hide-details class="mt-0 pt-0">
                          <v-radio :value="false" color="primary">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon small color="primary" class="mr-1">mdi-lock-open-variant</v-icon>
                                <span>Déverrouillé</span>
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="true" color="warning">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon small color="warning" class="mr-1">mdi-lock</v-icon>
                                <span>Verrouillé</span>
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </div>
                    </v-col>

                    <!-- Paiement -->
                    <v-col cols="12" sm="4" class="px-2">
                      <label class="field-label text-center d-block">Paiement</label>
                      <div class="radio-group">
                        <v-radio-group v-model="editedItem.deferredPayment" hide-details class="mt-0 pt-0">
                          <v-radio :value="false" color="teal">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon small color="teal" class="mr-1">mdi-cash-fast</v-icon>
                                <span>Immédiat</span>
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="true" color="indigo">
                            <template v-slot:label>
                              <div class="radio-label">
                                <v-icon small color="indigo" class="mr-1">mdi-clock-outline</v-icon>
                                <span>Différé</span>
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-container>
            </v-card-text>

            <v-card-actions class="modal-actions">
              <v-btn
                  @click="hide"
                  class="modal-cancel-btn"
                  depressed
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Annuler
              </v-btn>

              <v-btn
                  :disabled="!FormIsValidModif"
                  @click="updateWallet()"
                  class="modal-confirm-btn"
                  depressed
              >
                <v-icon left>mdi-check</v-icon>
                Confirmer
              </v-btn>
            </v-card-actions>
          </v-card>
        </modal>

        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export wallets</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" max-height="90vh" persistent v-model="dialog">
                <template v-slot:activator="{ on }">
                  <v-btn @click="init()" block class="custom-btn white--text" color="#009688" height="45px" large
                         v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Ajouter wallet</span>
                  </v-btn>
                </template>
                <v-card class="wallet-edit-card">
                  <v-toolbar color="#01579B" dark flat>
                    <v-toolbar-title>Ajout wallet</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" dark fab small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-alert :color="AlertColor(type)"
                           :dismissible="true"
                           :value="true"
                           border="top"
                           class="pre-formatted multi-line ma-0"
                           colored-border
                           elevation="2"
                           icon="check_circle"
                           v-if="type">
                    {{ text }}
                  </v-alert>

                  <v-card-text class="pb-0">
                    <v-container class="pa-2">
                      <v-card flat class="wallet-info-card pa-2">
                        <div class="wallet-info-header">
                          <v-chip color="primary" label small class="step-chip">
                            <v-icon small left>mdi-information-outline</v-icon>
                            Infos du wallet
                          </v-chip>
                        </div>

                        <!-- Sélection de l'employé -->
                        <v-row dense>
                          <v-col cols="12" class="py-1">
                            <label class="field-label">Employé</label>
                            <v-autocomplete
                                filled
                                dense
                                hide-details
                                v-model="editedItem.employeeId"
                                :items="employees"
                                item-text="label"
                                item-value="id"
                                :loading="loadingEmployees"
                                placeholder="Sélectionner un employé"
                                @change="updateEmployeeSelection">
                              <!-- Optional: Add back minimal styling -->
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.label }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <!-- Règles sur la même ligne -->
                        <v-row dense>
                          <v-col cols="12" sm="6" class="py-1">
                            <label class="field-label">Règle entreprise</label>
                            <v-select
                                filled
                                dense
                                hide-details
                                :items="ruleTypes"
                                item-text="name"
                                item-value="value"
                                class="centered-input mb-2"
                                v-model="editedItem.ruleCompany">
                            </v-select>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-1">
                            <label class="field-label">Règle personnelle</label>
                            <v-select
                                filled
                                dense
                                hide-details
                                :items="ruleTypes"
                                item-text="name"
                                item-value="value"
                                class="centered-input mb-2"
                                v-model="editedItem.rulePersonal">
                            </v-select>
                          </v-col>
                        </v-row>

                        <!-- Soldes sur la même ligne -->
                        <v-row dense>
                          <v-col cols="12" sm="6" class="py-1">
                            <label class="field-label">Solde entreprise</label>
                            <v-text-field
                                filled
                                dense
                                hide-details
                                type="number"
                                class="centered-input mb-2"
                                v-model="editedItem.soldeCompany">
                              <template v-slot:append>
                                <span class="currency-label">FCFA</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-1">
                            <label class="field-label">Solde personnel</label>
                            <v-text-field
                                filled
                                dense
                                hide-details
                                type="number"
                                class="centered-input mb-2"
                                v-model="editedItem.soldePersonnel">
                              <template v-slot:append>
                                <span class="currency-label">FCFA</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Modifiez les dropdowns comme suit -->
                        <v-row dense class="mt-2 wallet-controls">
                          <!-- État du wallet -->
                          <v-col cols="12" sm="4" class="px-2">
                            <label class="field-label text-center d-block">État du wallet</label>
                            <div class="radio-group">
                              <v-radio-group v-model="editedItem.disabled" hide-details class="mt-0 pt-0">
                                <v-radio :value="false" color="success">
                                  <template v-slot:label>
                                    <div class="radio-label">
                                      <v-icon small color="success" class="mr-1">mdi-check</v-icon>
                                      <span>Activé</span>
                                    </div>
                                  </template>
                                </v-radio>
                                <v-radio :value="true" color="error">
                                  <template v-slot:label>
                                    <div class="radio-label">
                                      <v-icon small color="error" class="mr-1">mdi-close</v-icon>
                                      <span>Désactivé</span>
                                    </div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </div>
                          </v-col>

                          <!-- Verrouillage -->
                          <v-col cols="12" sm="4" class="px-2">
                            <label class="field-label text-center d-block">Verrouillage</label>
                            <div class="radio-group">
                              <v-radio-group v-model="editedItem.locked" hide-details class="mt-0 pt-0">
                                <v-radio :value="false" color="primary">
                                  <template v-slot:label>
                                    <div class="radio-label">
                                      <v-icon small color="primary" class="mr-1">mdi-lock-open-variant</v-icon>
                                      <span>Déverrouillé</span>
                                    </div>
                                  </template>
                                </v-radio>
                                <v-radio :value="true" color="warning">
                                  <template v-slot:label>
                                    <div class="radio-label">
                                      <v-icon small color="warning" class="mr-1">mdi-lock</v-icon>
                                      <span>Verrouillé</span>
                                    </div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </div>
                          </v-col>

                          <!-- Paiement -->
                          <v-col cols="12" sm="4" class="px-2">
                            <label class="field-label text-center d-block">Paiement</label>
                            <div class="radio-group">
                              <v-radio-group v-model="editedItem.deferredPayment" hide-details class="mt-0 pt-0">
                                <v-radio :value="false" color="teal">
                                  <template v-slot:label>
                                    <div class="radio-label">
                                      <v-icon small color="teal" class="mr-1">mdi-cash-fast</v-icon>
                                      <span>Immédiat</span>
                                    </div>
                                  </template>
                                </v-radio>
                                <v-radio :value="true" color="indigo">
                                  <template v-slot:label>
                                    <div class="radio-label">
                                      <v-icon small color="indigo" class="mr-1">mdi-clock-outline</v-icon>
                                      <span>Différé</span>
                                    </div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>
                  </v-card-text>

                  <v-card-actions class="modal-actions">
                    <v-btn
                        @click="hide"
                        class="modal-cancel-btn"
                        depressed
                    >
                      <v-icon left>mdi-arrow-left</v-icon>
                      Annuler
                    </v-btn>

                    <v-btn
                        :disabled="!FormIsValid"
                        @click="createWallet()"
                        class="modal-confirm-btn"
                        depressed
                    >
                      <v-icon left>mdi-check</v-icon>
                      Confirmer
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="mt-4" elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "wallet",
  components: {HotTable},
  data: function () {
    return {
      walletStateOptions: [
        {value: false, text: '✅ Activé', color: '#4CAF50'},
        {value: true, text: '❌ Désactivé', color: '#F44336'}
      ],
      lockStateOptions: [
        {value: false, text: '🔓 Non verrouillé', color: '#2196F3'},
        {value: true, text: '🔒 Verrouillé', color: '#FF9800'}
      ],
      paymentOptions: [
        {value: false, text: '💰 Immédiat', color: '#009688'},
        {value: true, text: '💳 Différé', color: '#3F51B5'}
      ],
      employeeSearch: null,
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      loading: false,
      loading2: false,
      loadingEmployees: false,
      loadingCompanies: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      modifier: "",
      typeS: null,
      type: null,
      elapse: null,
      errors: [],
      excelData: [],
      toObject: [],
      ruleTypes: [
        {name: 'PREPAID', value: 'PREPAID'},
        {name: 'POSTPAID', value: 'POSTPAID'}
      ],
      employees: [],
      companies: [],
      editedItem: {
        id: "",
        employeeId: null,
        matricule: "",
        employeeName: "",
        companyId: null,
        companyName: "",
        ruleCompany: "POSTPAID",
        soldeCompany: 0,
        rulePersonal: "PREPAID",
        soldePersonnel: 0,
        disabled: false,
        locked: false,      // Ajout
        deferredPayment: false,  // Ajout
        creationDate: "",
        revisedDate: ""
      },
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start;
                  window.displayTitleModif(start.row);
                  window.updateData4Modif(start.row);
                  window.show();
                }, 0);
              }
            },
            sp1: '---------',
            remove_row: {
              name: "Supprimer"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 11, 12],  // Au lieu de [0, 8]
          indicators: false
        },
        colHeaders: [
          "Id", "Matricule", "Nom salarié", "Nom entreprise", "Régle entreprise", "Solde entreprise",
          "Régle personnelle", "Solde personnel", "Activé", "Verrouillé", "Paiement différé",  // Ajout
          "Date création", "Date révision"
        ],
        columns: [
          {title: "Id", width: "10px", readOnly: true},
          {title: "Matricule", width: "100px", readOnly: true},
          {title: "Nom salarié", width: "130px", readOnly: true},
          {title: "Nom entreprise", width: "150px", readOnly: true},
          {title: "Régle entreprise", width: "150px", type: "dropdown", source: ["PREPAID", "POSTPAID"]},
          {title: "Solde entreprise", width: "150px", type: "numeric"},
          {title: "Régle personnelle", width: "155px", type: "dropdown", source: ["PREPAID", "POSTPAID"]},
          {title: "Solde personnel", width: "150px", type: "numeric"},
          {title: "Activé", width: "80px", type: "checkbox"},
          {title: "Verrouillé", width: "100px", type: "checkbox"},  // Ajout
          {title: "Paiement différé", width: "150px", type: "checkbox"},  // Ajout
          {title: "Date création", width: "100px", align: "center", type: "date", readOnly: true},
          {title: "Date révision", width: "100px", align: "center", type: "date", readOnly: true}
        ]
      }
    }
  },

  created() {
    this.getData();

    this.testEmployees();
  },

  mounted() {
    window.show = this.show;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;
  },

  computed: {
    FormIsValid() {
      console.log("Checking form validity:", {
        employeeId: this.editedItem.employeeId,
        // Log other important properties for debugging
        matricule: this.editedItem.matricule,
        employeeName: this.editedItem.employeeName
      });

      // Le bouton est activé si employeeId a une valeur
      return this.editedItem.employeeId !== null &&
          this.editedItem.employeeId !== undefined;
    },
    FormIsValidModif() {
      return (
          this.editedItem.id !== "" &&
          this.editedItem.matricule !== ""
      );
    }
  },

  watch: {
    employees: {
      handler(newVal) {
        console.log("Watch triggered: employees changed", newVal.length);
      },
      deep: true
    }
  },

  methods: {
    testEmployees() {
      console.log("Adding test employees");

      // Create a test array of employees
      this.testEmployeesList = [
        {
          id: 1,
          userId: "TEST001",
          accountFirstname: "Test",
          accountLastname: "User",
          label: "USER Test (TEST001)"
        },
        {
          id: 2,
          userId: "TEST002",
          accountFirstname: "Jane",
          accountLastname: "Doe",
          label: "DOE Jane (TEST002)"
        }
      ];

      console.log("Test employees:", this.testEmployeesList);
    },

    displayTitleModif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.modifier = "Modification wallet de " + rowT[2];
    },

    updateData4Modif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.editedItem.id = rowT[0];
      this.editedItem.matricule = rowT[1];
      this.editedItem.employeeName = rowT[2];
      this.editedItem.companyName = rowT[3];
      this.editedItem.ruleCompany = rowT[4];
      this.editedItem.soldeCompany = this.extractNumericValue(rowT[5]);
      this.editedItem.rulePersonal = rowT[6];
      this.editedItem.soldePersonnel = this.extractNumericValue(rowT[7]);
      this.editedItem.disabled = !rowT[8];
      this.editedItem.locked = rowT[9];           // Ajout
      this.editedItem.deferredPayment = rowT[10]; // Ajout
      this.editedItem.creationDate = rowT[11];    // Mise à jour de l'index
      this.editedItem.revisedDate = rowT[12];     // Mise à jour de l'index
    },

    extractNumericValue(value) {
      if (typeof value === 'string') {
        // Supprimer les espaces, points comme séparateurs de milliers et "fcfa"
        const numericString = value.replace(/\s/g, '').replace(/\./g, '').replace('fcfa', '').trim();
        return parseInt(numericString) || 0;
      }
      return value || 0;
    },

    updateEmployeeSelection(selectedId) {
      console.log("Selected employee ID:", selectedId);

      // Assurez-vous que la propriété employeeId est mise à jour
      this.editedItem.employeeId = selectedId;

      if (selectedId) {
        // Trouve l'employé par ID
        const employee = this.employees.find(e => e.id === selectedId);

        if (employee) {
          this.editedItem.matricule = employee.userId || '';
          this.editedItem.employeeName = (employee.accountLastname || '').toUpperCase() + " " +
              this.capitalizeFirstLetters(employee.accountFirstname || '');

          console.log("Updated employee info:", {
            employeeId: this.editedItem.employeeId,
            matricule: this.editedItem.matricule,
            employeeName: this.editedItem.employeeName
          });
        }
      }
    },

    updateCompanySelection(companyId) {
      if (companyId) {
        // Trouve l'entreprise par ID
        const company = this.companies.find(c => c.id === companyId);

        if (company) {
          this.editedItem.companyName = company.name.toUpperCase();
          console.log("Updated company name:", this.editedItem.companyName);
        }
      }
    },

    capitalizeFirstLetters(str) {
      if (!str) return '';
      return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    },

    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },

    cleared() {
      this.searchName = "";
      this.getData();
    },

    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase();

      if (this.isEmpty(query)) {
        this.cleared();
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },

    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },

    hide() {
      this.$modal.hide('modal-fade');
    },

    loadEmployeesAndCompanies() {
      this.loadingEmployees = true;
      this.loadingCompanies = true;

      console.log("1. Starting loadEmployeesAndCompanies");
      console.log("2. baseUrl:", this.$store.getters.user.baseUrl);
      console.log("3. accountId:", sessionStorage.getItem("accountId"));

      // Charger les employés
      const employeeUrl = `${this.$store.getters.user.baseUrl}/account/users/${sessionStorage.getItem("userId")}`;
      console.log("4. Employee URL:", employeeUrl);

      apiClient
          .get(employeeUrl)
          .then(response => {
            console.log("5. Received employee response");
            this.loadingEmployees = false;

            if (response.data && response.data.status === 200) {
              console.log("6. Response status is 200");

              // Check if datas array exists and has items
              if (response.data.datas && Array.isArray(response.data.datas) && response.data.datas.length > 0) {
                console.log("7. Found", response.data.datas.length, "employees in response");
                console.log("8. First employee:", response.data.datas[0]);

                // Log all properties of the first employee
                if (response.data.datas[0]) {
                  console.log("9. Employee properties:", Object.keys(response.data.datas[0]));
                }

                // Map to a simpler structure that matches what the autocomplete needs
                this.employees = response.data.datas.map(employee => {
                  const mappedEmployee = {
                    id: employee.id,
                    userId: employee.userId || '',
                    accountFirstname: employee.accountFirstname || '',
                    accountLastname: employee.accountLastname || '',
                    label: ((employee.accountLastname || '').toUpperCase() + " " +
                        this.capitalizeFirstLetters(employee.accountFirstname || '') +
                        (employee.userId ? " (" + employee.userId + ")" : ""))
                  };

                  return mappedEmployee;
                });

                console.log("10. Mapped employees (first 3):", this.employees.slice(0, 3));

                // Force reactivity by setting a new array
                this.$set(this, 'employees', [...this.employees]);
              } else {
                console.warn("7b. No employee data in response:", response.data);
                this.employees = [];
              }
            } else {
              console.error("6b. Invalid response:", response.data);
              this.employees = [];
            }
          })
          .catch(error => {
            console.error("5b. Error fetching employees:", error);
            this.loadingEmployees = false;
            this.employees = [];
          });
    },

    initEditedItem() {
      this.editedItem = {
        id: "",
        employeeId: null,  // Sera maintenant un ID au lieu d'un objet
        matricule: "",
        employeeName: "",
        companyId: null,   // Sera maintenant un ID au lieu d'un objet
        companyName: "",
        ruleCompany: "POSTPAID",
        soldeCompany: 0,
        rulePersonal: "PREPAID",
        soldePersonnel: 0,
        disabled: false,
        locked: false,           // Ajout
        deferredPayment: true,  // Ajout
        creationDate: "",
        revisedDate: ""
      };
    },

    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render();
    },

    getData() {
      this.loading = true;
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallets/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false;
            let tabArray = [];
            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["employee"].userId,
                item["employee"].accountLastname.toUpperCase() + " " + item["employee"].accountFirstname.toLowerCase().capitalize(true),
                item["walletCompany"].name.toUpperCase(),
                item["ruleCompany"],
                item["soldeCompany"],
                item["rulePersonal"],
                item["soldePersonnel"],
                !item["disabled"],
                item["locked"],          // Ajout
                item["deferredPayment"], // Ajout
                this.datefull(item["creationDate"]),
                this.datefull(item["revisedDate"])
              ]);
            });

            this.$refs.hotTable.hotInstance.loadData(tabArray);
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
          })
          .catch(() => {
            this.loading = false;
          });
    },

    onCancel() {
      this.loading = false;
    },

    refresh() {
      this.getData();
    },

    datefull(val) {
      if (!val) {
        return;
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },

    close() {
      this.dialog = false;
      this.initEditedItem();
    },

    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlert(type) {
      this.type = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlertS(type) {
      this.typeS = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide();
        }
        this.typeS = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    dismissible_close() {
      this.elapse = 3;
      clearTimeout(this.showAlert.timer);
      clearInterval(this.showAlert.t);
      this.type = null;
    },

    onexport() {
      this.loading = true;
      // export json to Worksheet of Excel
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true});

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      XLSX.utils.book_append_sheet(wb, datas, "Wallets");

      // export Excel file
      XLSX.writeFile(wb, "Wallets.xlsx");
      this.loading = false;
    },

    // Création d'un nouveau wallet
    createWallet() {
      if (!this.FormIsValid) {
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const employeeId = this.editedItem.employeeId;
      const ruleCompany = this.editedItem.ruleCompany;
      const rulePersonal = this.editedItem.rulePersonal;
      const soldeCompany = this.editedItem.soldeCompany;
      const soldePersonnel = this.editedItem.soldePersonnel;
      const disabled = this.editedItem.disabled;
      const locked = this.editedItem.locked;                    // Ajout
      const deferredPayment = this.editedItem.deferredPayment; // Ajout
      const sender_id = sessionStorage.getItem("accountId");

      const url = `${baseUrl}/wallet/add_wallet/${employeeId}/${ruleCompany}/${rulePersonal}/${soldeCompany}/${soldePersonnel}/${disabled}/${locked}/${deferredPayment}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.dialog = false;
              this.getData();
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning');
            }
          })
          .catch(err => {
            this.text = err;
            this.dialog = false;
            this.loading = false;
            this.color = "#F44336";
            this.showAlert('warning');
          });
    },

    // Mise à jour d'un wallet existant
    updateWallet() {
      if (!this.FormIsValidModif) {
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const wallet_id = this.editedItem.id;
      const rule_company = this.editedItem.ruleCompany;
      const rule_personal = this.editedItem.rulePersonal;
      const solde_company = this.editedItem.soldeCompany;
      const solde_personnel = this.editedItem.soldePersonnel;
      const disabled = this.editedItem.disabled;
      const locked = this.editedItem.locked;                    // Ajout
      const deferredPayment = this.editedItem.deferredPayment; // Ajout
      const sender_id = sessionStorage.getItem("accountId");

      // Construction de l'URL avec les paramètres corrects selon la définition de l'endpoint
      const url = `${baseUrl}/wallet/update_wallet/${wallet_id}/${rule_company}/${rule_personal}/${solde_company}/${solde_personnel}/${disabled}/${locked}/${deferredPayment}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.hide();
              this.getData();
              this.initEditedItem();
              this.showAlertS('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.showAlertS('warning');
            }
          })
          .catch(err => {
            this.text = err;
            this.loading = false;
            this.color = "#F44336";
            this.showAlertS('warning');
          });
    },

    // Gestion des modifications directes dans le tableau
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du wallet.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              const row = changes[0][0];
              const col = changes[0][1];
              const newValue = changes[0][3];

              let obj = this.$refs.hotTable.hotInstance.getData()[row];

              const wallet_id = obj[0];
              let rule_company = obj[4];
              let rule_personal = obj[6];
              let solde_company = this.extractNumericValue(obj[5]);
              let solde_personnel = this.extractNumericValue(obj[7]);
              let disabled = !obj[8];
              let locked = obj[9];                    // Ajout
              let deferredPayment = obj[10];

              // Mettre à jour la valeur modifiée
              if (col === 4) { // Règle entreprise
                rule_company = newValue;
              } else if (col === 5) { // Solde entreprise
                solde_company = this.extractNumericValue(newValue);
              } else if (col === 6) { // Règle personnelle
                rule_personal = newValue;
              } else if (col === 7) { // Solde personnel
                solde_personnel = this.extractNumericValue(newValue);
              } else if (col === 8) { // Valide (inverser pour disabled)
                disabled = !newValue;
              } else if (col === 9) { // Locked  // Ajout
                locked = newValue;
              } else if (col === 10) { // DeferredPayment  // Ajout
                deferredPayment = newValue;
              }

              const baseUrl = this.$store.getters.user.baseUrl;
              const sender_id = sessionStorage.getItem("accountId");

              // Construction de l'URL avec les paramètres corrects
              const url = `${baseUrl}/wallet/update_wallet/${wallet_id}/${rule_company}/${rule_personal}/${solde_company}/${solde_personnel}/${disabled}/${locked}/${deferredPayment}/${sender_id}`;

              apiClient
                  .post(url)
                  .then(res => {
                    dialog.close();
                    this.loading = false;
                    if (res.data.status === 200) {
                      this.color = "#009688";
                      this.text = res.data.message;
                      this.showAlert('info');
                      this.getData();
                    } else {
                      this.color = "#F44336";
                      this.text = res.data.message;

                      // Restaurer la valeur précédente
                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[row][col] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    dialog.close();

                    // Restaurer la valeur précédente
                    let myData = this.$refs.hotTable.hotInstance.getData();
                    myData[row][col] = changes[0][2];
                    this.$refs.hotTable.hotInstance.loadData(myData);

                    this.color = "#F44336";
                    this.text = err.data ? err.data.message : err;
                    this.showAlert('warning');
                  });
            })
            .catch(() => {
              this.loading = false;
              // Restaurer la valeur précédente
              let myData = this.$refs.hotTable.hotInstance.getData();
              myData[changes[0][0]][changes[0][1]] = changes[0][2];
              this.$refs.hotTable.hotInstance.loadData(myData);
            });
      }
    },

    // Gestion de la suppression d'une ligne
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index];
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du wallet.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            // Récupérer l'ID du wallet à supprimer
            const wallet_id = rowId[0];
            const sender_id = sessionStorage.getItem("accountId");

            // Utiliser le bon endpoint pour la suppression
            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_by_id/${wallet_id}/${sender_id}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                  } else {
                    // Restaurer la ligne
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.color = "#F44336";
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;

                  // Restaurer la ligne
                  this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                  this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                  this.color = "#F44336";
                  this.text = error;
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // Restaurer la ligne
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
          });
    },

    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    // Méthode pour ajuster la hauteur des dialogues selon l'appareil
    adjustDialogHeight() {
      // Déterminer si nous sommes sur un appareil mobile
      const isMobile = window.innerWidth < 600;

      // Définir la hauteur maximale pour le dialogue principal et modal
      const maxHeight = isMobile ? '100vh' : '90vh';

      // Appliquer aux éléments du DOM
      const dialogs = document.querySelectorAll('.v-dialog');
      dialogs.forEach(dialog => {
        dialog.style.maxHeight = maxHeight;
      });

      // Pour les modals (si vous utilisez vue-js-modal)
      const modalContainer = document.querySelector('.v--modal-overlay .v--modal-box');
      if (modalContainer) {
        modalContainer.style.maxHeight = maxHeight;
        modalContainer.style.height = 'auto';
        modalContainer.style.overflowY = 'auto';
      }
    },

    // Ajouter cette ligne à votre méthode show()
    show() {
      this.$modal.show('modal-fade');

      // Ajuster la hauteur du modal après son ouverture
      this.$nextTick(() => {
        // Sélectionnez le conteneur modal
        const modalContainer = document.querySelector('.v--modal-overlay .v--modal-box');
        if (modalContainer) {
          // Définir une hauteur maximale en pixels (équivalent à 90vh)
          const viewportHeight = window.innerHeight;
          const maxHeightInPixels = Math.floor(viewportHeight * 0.9);

          // Appliquer la hauteur maximale en pixels
          modalContainer.style.maxHeight = maxHeightInPixels + 'px';
          modalContainer.style.height = 'auto';
          modalContainer.style.overflowY = 'auto';
        }
      });
    },

    adjustModalHeight() {
      const viewportHeight = window.innerHeight;
      const maxHeightInPixels = Math.floor(viewportHeight * 0.9);
      const modalContainer = document.querySelector('.v--modal-overlay .v--modal-box');

      if (modalContainer) {
        modalContainer.style.maxHeight = maxHeightInPixels + 'px';
      }
    },

    // Ajouter cette ligne à votre méthode init()
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.initEditedItem();
      this.loadEmployeesAndCompanies();
      this.$nextTick(() => {
        this.adjustDialogHeight();
      });
    }
  }
};
</script>

<style scoped>
/* =====================
   Styles de base
   ===================== */
.toolbar .v-toolbar__content {
  padding: 0 !important;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent;
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

/* =====================
   Tableaux HandsOnTable
   ===================== */
.area.highlight,
.htCenter.htMiddle.highlight {
  background-color: #d0e1ef !important;
}

/* =====================
   Formulaires et champs
   ===================== */
/* Texte centré dans les inputs */
.centered-input >>> input {
  text-align: center !important;
}

/* =====================
   Modales et dialogues
   ===================== */
/* Carte de modification */
.wallet-edit-card {
  border-radius: 8px;
  overflow: hidden;
}

.wallet-edit-card .v-toolbar {
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Titre de la modale */
.modal-title .v-input__slot {
  margin-bottom: 0 !important;
  padding: 0 12px !important;
  background-color: rgba(255, 255, 255, 0.15) !important;
}

/* Carte d'information */
.wallet-info-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fcfcfc;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Puce d'étape */
.step-chip {
  border-radius: 16px;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

/* Labels de champs */
.field-label {
  display: block;
  font-size: 12px;
  color: #757575;
  margin-bottom: 4px;
  font-weight: 500;
}

/* Currency label */
.currency-label {
  font-size: 12px;
  color: #757575;
  opacity: 0.8;
}

/* =====================
   Boutons et actions
   ===================== */
.v-card-actions .v-btn {
  min-width: 120px;
  margin: 0 8px;
}

/* =====================
   Vue-js-modal styles
   ===================== */
.v--modal {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}

.v--modal-overlay {
  background: rgba(0, 0, 0, 0.5) !important;
}

/* Styles pour les groupes de toggle */
.toggle-group {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 2px;
  width: 100%;
}

/* Styles de base pour les boutons toggle */
.toggle-btn {
  flex: 1;
  text-transform: none;
  letter-spacing: normal;
  font-size: 12px;
  height: 32px;
  margin: 0;
  transition: all 0.3s ease;
  border: none !important;
  box-shadow: none !important;
}

/* Style pour les groupes de radio */
.radio-group {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  background-color: #fafafa;
}

/* Style pour les labels des radios */
.radio-label {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

/* Style pour les radios sélectionnées */
.v-radio--is-selected .radio-label {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Espacement entre les options */
.v-input--radio-group__input > div {
  margin-bottom: 4px;
}

/* Supprime le padding inutile */
.v-input--radio-group.v-input--radio-group--row .v-input--radio-group__input {
  padding: 0;
}

/* Adaptations mobile */
@media (max-width: 600px) {
  .radio-group {
    padding: 6px;
  }

  .radio-label {
    font-size: 13px;
    padding: 2px 4px;
  }

  .radio-label .v-icon {
    font-size: 16px;
  }
}

.radio-group .v-radio:hover {
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}

/* En-tête de modal */
.modal-header {
  background: linear-gradient(135deg, #01579B 0%, #002f6c 100%) !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 0 16px !important;
}

.modal-title {
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  font-size: 1.1rem !important;
}

.close-btn {
  transition: all 0.3s ease !important;
}

.close-btn:hover {
  transform: rotate(90deg);
  background: rgba(255, 255, 255, 0.1) !important;
}

/* Zone de contenu */
.v-card__text.modal-content {
  padding: 24px !important;
  background-color: #fafafa;
}

/* Actions de modal */
.modal-actions {
  padding: 16px 24px !important;
  background: #f5f5f5 !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex;
  justify-content: space-between;
}

.modal-cancel-btn {
  background: white !important;
  border: 1px solid #e0e0e0 !important;
  color: #757575 !important;
  border-radius: 8px !important;
  min-width: 120px !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  transition: all 0.3s ease !important;
}

.modal-cancel-btn:hover {
  border-color: #bdbdbd !important;
  background: #f5f5f5 !important;
}

.modal-confirm-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%) !important;
  color: white !important;
  border-radius: 8px !important;
  min-width: 140px !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: 0 2px 4px rgba(76, 175, 80, 0.2) !important;
  transition: all 0.3s ease !important;
}

.modal-confirm-btn:hover {
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px);
}

.modal-confirm-btn:disabled {
  background: #e0e0e0 !important;
  color: #9e9e9e !important;
  box-shadow: none !important;
  transform: none !important;
}

/* Champs de formulaire dans la modal */
.modal-content .v-input {
  margin-bottom: 12px !important;
}

.modal-content .v-input__slot {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  border-radius: 6px !important;
}

/* Animation d'entrée */
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(2px);
  transition: all 0.3s ease;
}

.v--modal-box {
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Responsive */
@media (max-width: 600px) {
  .modal-header {
    padding: 0 12px !important;
  }

  .modal-title {
    font-size: 1rem !important;
  }

  .modal-actions {
    padding: 12px !important;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .modal-cancel-btn,
  .modal-confirm-btn {
    width: 100% !important;
    margin: 0 !important;
  }
}
</style>